import styled from "styled-components";

const ContactUsStylesStylesContainer = styled.section`
    margin: 0 0 40px;

    
`;
export { ContactUsStylesStylesContainer };
